import { render, staticRenderFns } from "./DropFileSoporte.vue?vue&type=template&id=93082c76&scoped=true"
import script from "./DropFileSoporte.vue?vue&type=script&lang=js"
export * from "./DropFileSoporte.vue?vue&type=script&lang=js"
import style0 from "./DropFileSoporte.vue?vue&type=style&index=0&id=93082c76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93082c76",
  null
  
)

export default component.exports